import CareersComponent from "components/pages/careers/careers-component";
import ErrorCareersComponent from "components/pages/careers/error-careers-component/error-careers-component";
import { getDataFromComeet } from "/server/services/comeet-service/comeet-service";
import { CAREERS_ERROR_RENDERED } from "/constants/bigbrain-event-types";
import { CAREERS_PAGE } from "/constants/careers/careers";
import { filterByPositionType } from "components/pages/careers/careers-service";
import BaseTemplatePage from "../../generated-templates/base-template-page";
import { InternalServerError } from "server/extensions/error-extensions";
import { INTERNAL_SERVER_ERROR_CODE } from "constants/status-codes";
import { getGeneratorSystemConfigOnRequest } from "server/services/request-service/request-service";

export default class CareersPage extends BaseTemplatePage {
  static async getInitialProps({ req, res, asPath, query }) {
    const {
      handleServerException
    } = require("../../../server/services/exceptions-handling-service/exceptions-handling-service");
    const superInitialProps = await BaseTemplatePage.getInitialProps({ req, res, asPath });
    const { translations, isMobileOrTabletBrowser, cloudfrontViewerCountry } = superInitialProps;

    const { positionsType } = query;

    try {
      const allPositionsData = await getDataFromComeet();

      if (!allPositionsData || allPositionsData.ERROR) {
        throw new InternalServerError("error fetching positions data");
      }
      const positionsData = filterByPositionType(allPositionsData, positionsType);
      return {
        positionsData,
        translations,
        asPath,
        isTypeformDisabled: getGeneratorSystemConfigOnRequest(req)?.isTypeformDisabled,
        positionsType,
        isMobileOrTabletBrowser,
        cloudfrontViewerCountry
      };
    } catch (e) {
      await handleServerException({ e, req, res, bbEventParams: { name: CAREERS_ERROR_RENDERED, kind: CAREERS_PAGE } });
      res.statusCode = INTERNAL_SERVER_ERROR_CODE;
      return {
        translations
      };
    }
  }

  render() {
    const { positionsData, translations } = this.props;
    if (!positionsData) return <ErrorCareersComponent translations={translations} />;
    return <CareersComponent {...this.props} />;
  }
}
